import { putCommunication } from '../actions/communication';
import { createReducer } from '@reduxjs/toolkit';

export default createReducer({}, (builder) => {
  builder.addCase(putCommunication, (state, action) =>
    ({ ...state, [action.payload.QID]: action.payload }))
});
